import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/list-duck";
import { BoardingConditions } from "interfaces/boarding-conditions";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "LIST_BOARDING_CONDITIONS_" }
);

export interface ListBoardingConditionsState extends IState {
  data: BoardingConditions[];
}

interface ISuccessListUnitsAction extends ISuccessAction {
  data: BoardingConditions[];
}

const INITIAL_STATE: ListBoardingConditionsState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListBoardingConditionsState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: ListBoardingConditionsState, action: ISuccessListUnitsAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListBoardingConditionsState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listBoardingConditions = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListBoardingConditionsTypes = Types;
export const ListBoardingConditionsActions = Creators;
